<h3 [class]="class">
  <a *ngIf="!menuOption.children || menuOption.children.length === 0" class="header__menu-content-text px-3"
    [routerLink]="[ menuOption.url ]" (click)="onLinkClick()">
    <i *ngIf="menuOption.icon" class="{{class}}-icon {{menuOption.icon}}"></i>{{menuOption.name}}
  </a>

  <span tabindex="0" *ngIf="menuOption.children && menuOption.children.length > 0"
    class="header__menu-content-text justify-content-between px-3" (click)="onItemClick()"
    (keypress)="onKeyEnter($event)">
    <span>
      <i *ngIf="menuOption.icon" class="{{class}}-icon {{menuOption.icon}}"></i>{{menuOption.name}}
    </span>

    <span>
      <i class="header__menu-subcontent-icon fas ml-2"
        [ngClass]="{ 'fa-plus': !menuOption.isSelected, 'fa-minus': menuOption.isSelected }"></i>
    </span>
  </span>

  <ul *ngIf="menuOption.isSelected" class="header__menu-list">
    <li class="header__menu-item" *ngFor="let suboption of menuOption.children">
      <ms-khuyana-header-submenu [menuOption]="suboption" (selected)="suboption.isSelected = $event"
        (leave)="onLinkClick()" class="header__menu-subcontent"></ms-khuyana-header-submenu>
    </li>
  </ul>
</h3>